module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content"
  }, [(!_vm.contents) ? _c('div', {
    staticClass: "inner"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contents),
      expression: "contents"
    }],
    staticClass: "inner"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isCarrier(_vm.platformName) && _vm.showNews),
      expression: "!isCarrier(platformName) && showNews"
    }],
    staticClass: "iframe-container",
    attrs: {
      "id": "purchased-news-container"
    }
  }, [_c('iframe', {
    attrs: {
      "id": "purchased-news",
      "src": _vm.newsUrl,
      "scrolling": "no",
      "frameborder": "0"
    }
  })]), _vm._v(" "), (_vm.contents) ? [(0 < _vm.contents.length) ? _vm._l((_vm.contents), function(detail) {
    return _c('div', {
      key: detail.contentid,
      staticClass: "card-contents"
    }, [_c('div', {
      staticClass: "flexcenternowrap",
      on: {
        "click": function($event) {
          return _vm.showDetail(detail)
        }
      }
    }, [_c('div', {
      staticClass: "cover-image"
    }, [_c('img', {
      attrs: {
        "src": _vm.getContentsThumbnailPath(detail.contentid, _vm.showScreen),
        "alt": detail.content_name
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-content"
    }, [_c('div', {
      staticClass: "flexbetween"
    }, [_c('div', {
      staticClass: "content-name font28"
    }, [_vm._v(_vm._s(detail.content_name))])]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('div', {
      staticClass: "rate"
    }, [(detail.progress == 100) ? _c('span', [_vm._v("★")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "progress"
    }, [_c('p', [_vm._v("学習進捗状況")]), _vm._v(" "), _c('div', {
      staticClass: "flexbox"
    }, [_c('div', {
      staticClass: "progress-bar"
    }, [_c('div', {
      staticClass: "data",
      style: ({
        width: detail.progress + '%'
      })
    })]), _vm._v(" "), _c('div', {
      staticClass: "percentage font14"
    }, [_vm._v(_vm._s(detail.progress) + "%")])])])]), _vm._v(" "), _vm._m(0, true)])])])
  }) : (_vm.isMobile) ? [_c('div', {
    staticClass: "no-contents"
  }, [(!_vm.isPlatformiOS(_vm.platformName)) ? _c('div', {
    staticClass: "align-center"
  }, [_c('p', {
    staticClass: "font24"
  }, [_vm._v("購入済みのコンテンツがありません")]), _vm._v(" "), _c('p', [_vm._v("ストアよりコンテンツを購入できます。")])]) : _c('div', {
    staticClass: "align-center"
  }, [_c('p', {
    staticClass: "font24"
  }, [_vm._v("AppStoreでご購入済みの場合")]), _vm._v(" "), _c('p', [_vm._v("右上の[?]-[復元する]を選択します")]), _vm._v(" "), _c('p', {
    staticClass: "font24"
  }, [_vm._v("上記以外でご購入済みの場合")]), _vm._v(" "), _c('p', [_vm._v("右上の[?]-[PCや別の端末と連携する]からサインインします")])]), _vm._v(" "), _c('div', {
    staticClass: "content-button"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeView', 'StoreList')
      }
    }
  }, [_vm._v("コンテンツを購入する")])])])] : [_c('div', {
    staticClass: "no-contents"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "content-button"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('changeView', 'StoreList')
      }
    }
  }, [_vm._v("コンテンツを購入する")])])])]] : _vm._e()], 2), _vm._v(" "), (_vm.showContentDeactivation) ? _c('ContentDeactivation', {
    attrs: {
      "contentDetail": _vm.deactivateContent
    },
    on: {
      "close": function($event) {
        _vm.showContentDeactivation = false
      },
      "deactivate": _vm.doContentDeactivate
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-button"
  }, [_c('button', [_c('img', {
    attrs: {
      "src": "static/images/icon/png/ar_r_circle_gray.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "align-center"
  }, [_c('p', {
    staticClass: "font24"
  }, [_vm._v("利用開始済みのコンテンツがありません")]), _vm._v(" "), _c('div', [_vm._v("コンテンツ未購入の場合は、ストアよりご購入ください。")]), _vm._v(" "), _c('div', [_vm._v("購入済みのコンテンツがある場合は、マイページより利用開始手続きを行なってください")]), _vm._v(" "), _c('p', [_vm._v("マイページは "), _c('a', {
    attrs: {
      "href": "https://www.sourcenext.com/users/action/utop",
      "target": "_blank"
    }
  }, [_vm._v("こちら>>")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-253bd42d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-253bd42d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/purchased/PurchasedList.vue
// module id = 710
// module chunks = 1